import api from "@services/api-service";
import queryParams from "@services/repository-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    cobrancas: []
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {},

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    fetchParamsCobrancas: () => ({
      page,
      sortedBy,
      orderBy,
      cod,
      nome,
      contrato,
      cpf,
      formaPagamento,
      criacao
    }) =>
      queryParams({
        page: page,
        relationships: ["cliente", "contrato", "formaPagamento"],
        where: [
          ["id", "=", cod],
          ["cliente.nome", "like", nome],
          ["cliente.cpf", "like", cpf],
          ["formaPagamento.id", "like", formaPagamento],

          ["contrato.id", "like", contrato],
          ["created_at", "between", criacao]
        ],
        sortedBy: sortedBy,
        orderBy: orderBy
      }),

    fetchCobrancas: () => async options =>
      await api().get(`cobrancas`, {
        params: store.getters.fetchParamsCobrancas()(options)
      })
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {}
};

export default store;
